import React from 'react';
import {ListConfigNamedColumn} from '@src/@types/components/List';
import ListColumn from './ListColumn';
import {IListConfigNumberColumn} from '@src/@interfaces/components/List/IListConfigNumberColumn';
import {IEmptyModel} from '@src/@interfaces/IEmptyModel';
import FormattedPrice from '@src/components/FormattedPrice/FormattedPrice';

export default class PriceColumn<
        Model extends IEmptyModel = IEmptyModel
> extends ListColumn<ListConfigNamedColumn<IListConfigNumberColumn>, Model> {
    protected get value(): any {
        return super.value / 100;
    }

    render() {
        return <FormattedPrice>{this.value}</FormattedPrice>;
    }
}
